// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2EL1s","left":"StickyBox_left__34SzH","right":"StickyBox_right__1Rx9T"};